import {Header} from './layout/Header'
import {Footer} from './layout/Footer'
import {Main} from './layout/Main'

function App() {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
}

export default App;
